// src/components/Header.jsx

import React from 'react';
import logo from '../assets/logo.png'; // Make sure this path is correct
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

import { Button } from '../components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { LogOut, LayoutDashboard } from 'lucide-react';

export const Header = ({ className = '' }) => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(() => navigate('/')); // Redirect to login page after logout
  };

  const getInitials = (name = "") =>
    name
      .split(' ')
      .map(n => n[0])
      .filter(Boolean)
      .join('')
      .toUpperCase()
      .slice(0, 2);

  if (loading) {
    return null;
  }

  const displayName = user?.sUserName || user?.email || "Admin";
  const userInitials = getInitials(displayName);
  const userAvatarSrc = user?.avatarUrl;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-4 sm:px-6 py-2 bg-white shadow-md ${className}`}>
      <div className="flex items-center">
        <img
          src={logo}
          alt="Selyst Logo"
          className="h-10 sm:h-12 max-w-[120px] object-contain cursor-pointer"
          onClick={() => navigate(user ? '/admin/dashboard' : '/')}
        />
      </div>

      <nav className="flex items-center gap-3 lg:gap-4">
        {user ? (
          <>
            <Button variant="link" onClick={() => navigate('/admin/dashboard')} className="text-base font-medium">
              Dashboard
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="relative h-9 w-9 rounded-full">
                  <Avatar className="h-9 w-9">
                    {userAvatarSrc && <AvatarImage src={userAvatarSrc} alt={displayName} />}
                    <AvatarFallback>{userInitials}</AvatarFallback>
                  </Avatar>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-56" align="end" forceMount>
                <DropdownMenuLabel className="font-normal">
                  <div className="flex flex-col space-y-1">
                    <p className="text-sm font-medium leading-none">{displayName}</p>
                    {user.email && <p className="text-xs leading-none text-muted-foreground">{user.email}</p>}
                  </div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate('/admin/dashboard')} className="cursor-pointer">
                  <LayoutDashboard className="mr-2 h-4 w-4" />
                  <span>Dashboard</span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
                  <LogOut className="mr-2 h-4 w-4" />
                  <span>Logout</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        ) : null}
      </nav>
    </header>
  );
};